import * as React from "react";
import { FormControl } from "@mui/base/FormControl";
import { InputLabel, TextField, TextFieldProps, useTheme } from "@mui/material";
import { Control, Controller } from "react-hook-form";

export type InputFieldProps = {
    color?: "primary" | "secondary";
    size?: "small" | "medium";
    label?: string | "";
    name: string;
    control: Control<any, any>;
    controllerName: string;
    rules?: Object; 
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & TextFieldProps;

const CustomInputField: React.FC<InputFieldProps> = ({
    size,
    color,
    label,
    name,
    control,
    controllerName,
    rules,
    onChange,
    ...props
}) => {
    const theme = useTheme();
    return (
        <FormControl>
            {label && <InputLabel>{label}</InputLabel>}
            <Controller
                name={controllerName || ""}
                control={control}
                rules={rules ?? {}}
                render={({ field }) => (
                    <TextField
                        style={{ paddingTop: '5px' }}
                        fullWidth
                        type="text"
                        size={size || "small"}
                        color={color || (theme.palette.mode === "dark" ? "secondary" : "primary")}
                        variant="outlined"
                        {...field}
                        {...props}
                        onChange={(e) => {
                            field.onChange(e);
                            onChange && onChange(e);
                        }}
                    />
                )}
            />
        </FormControl>
    );
};

export default CustomInputField;